import React, {createContext, useContext, useState, ReactNode} from 'react';

interface ContextType {
    notifications_enabled: boolean;
    settings_enabled: boolean;
    calendar_enabled: boolean;
    tutorial_enabled: boolean;
    billing_enabled: boolean;
    set_notifications_enabled: (value: boolean) => void;
    set_settings_enabled: (value: boolean) => void;
    set_calendar_enabled: (value: boolean) => void;
    set_tutorial_enabled: (value: boolean) => void;
    set_billing_enabled: (value: boolean) => void;
}

const SettingsContext = createContext<ContextType | undefined>(undefined);

export const SettingsProvider = ({
                                     children,
                                     defaults,
                                 }: {
    children: ReactNode;
    defaults: Omit<ContextType, 'set_notifications_enabled' | 'set_settings_enabled' | 'set_calendar_enabled' | 'set_tutorial_enabled' | 'set_billing_enabled'>;
}) => {
    const [notifications_enabled, set_notifications_enabled] = useState(defaults.notifications_enabled);
    const [settings_enabled, set_settings_enabled] = useState(defaults.settings_enabled);
    const [calendar_enabled, set_calendar_enabled] = useState(defaults.calendar_enabled);
    const [tutorial_enabled, set_tutorial_enabled] = useState(defaults.tutorial_enabled);
    const [billing_enabled, set_billing_enabled] = useState(defaults.billing_enabled);

    return <SettingsContext.Provider
        value={{
            notifications_enabled,
            settings_enabled,
            calendar_enabled,
            tutorial_enabled,
            billing_enabled,
            set_notifications_enabled,
            set_settings_enabled,
            set_calendar_enabled,
            set_tutorial_enabled,
            set_billing_enabled
        }}>
        {children}
    </SettingsContext.Provider>
};

export const useSettings = () => {
    const context = useContext(SettingsContext);
    if (!context) {
        throw new Error('useSettings must be used within a SettingsProvider');
    }
    return context;
};
